import am from '../locales/am.json';
import ar from '../locales/ar.json';
import bg from '../locales/bg.json';
import bn from '../locales/bn.json';
import ca from '../locales/ca.json';
import cs from '../locales/cs.json';
import da from '../locales/da.json';
import de from '../locales/de.json';
import el from '../locales/el.json';
import en from '../locales/en.json';
import es from '../locales/es.json';
import fa from '../locales/fa.json';
import fi from '../locales/fi.json';
import fil from '../locales/fil.json';
import fr from '../locales/fr.json';
import he from '../locales/he.json';
import hi from '../locales/hi.json';
import hr from '../locales/hr.json';
import hu from '../locales/hu.json';
import id from '../locales/id.json';
import it from '../locales/it.json';
import ja from '../locales/ja.json';
import ka from '../locales/ka.json';
import kn from '../locales/kn.json';
import ko from '../locales/ko.json';
import ku from '../locales/ku.json';
import lb from '../locales/lb.json';
import ml from '../locales/ml.json';
import mn from '../locales/mn.json';
import ms from '../locales/ms.json';
import my from '../locales/my.json';
import nl from '../locales/nl.json';
import no from '../locales/no.json';
import pa from '../locales/pa.json';
import pl from '../locales/pl.json';
import pt from '../locales/pt.json';
import ro from '../locales/ro.json';
import ru from '../locales/ru.json';
import si from '../locales/si.json';
import sk from '../locales/sk.json';
import sl from '../locales/sl.json';
import sr from '../locales/sr.json';
import srSP from '../locales/sr-SP.json';
import sv from '../locales/sv.json';
import sw from '../locales/sw.json';
import ta from '../locales/ta.json';
import te from '../locales/te.json';
import th from '../locales/th.json';
import tr from '../locales/tr.json';
import ur from '../locales/ur.json';
import vi from '../locales/vi.json';
import zhHans from '../locales/zh-Hans.json';
import zhHant from '../locales/zh-Hant.json';

export const ALL_LOCALES: Record<string, Record<string, string>> = {
  am,
  ar,
  bg,
  bn,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  fa,
  fi,
  fil,
  fr,
  he,
  hi,
  hr,
  hu,
  id,
  it,
  ja,
  ka,
  kn,
  ko,
  ku,
  lb,
  ml,
  mn,
  ms,
  my,
  nl,
  no,
  pa,
  pl,
  pt,
  ro,
  ru,
  si,
  sk,
  sl,
  sr,
  'sr-SP': srSP,
  sv,
  sw,
  ta,
  te,
  th,
  tr,
  ur,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};

export {
  am,
  ar,
  bg,
  bn,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  fa,
  fi,
  fil,
  fr,
  he,
  hi,
  hr,
  hu,
  id,
  it,
  ja,
  ka,
  kn,
  ko,
  ku,
  lb,
  ml,
  mn,
  ms,
  my,
  nl,
  no,
  pa,
  pl,
  pt,
  ro,
  ru,
  si,
  sk,
  sl,
  sr,
  srSP,
  sv,
  sw,
  ta,
  te,
  th,
  tr,
  ur,
  vi,
  zhHans,
  zhHant,
  en as enLocale,
  id as idLocale,
};

export default ALL_LOCALES;
